/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { EventTopic } from "./EventTopic";
import { BaseEvent } from "./BaseEvent";
export const CreateEventConfig = core.serialization
    .object({
    topic: EventTopic,
    payload: core.serialization.record(core.serialization.string(), core.serialization.any()),
    deletedAt: core.serialization.date().optional(),
})
    .extend(BaseEvent);
